import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ApiModule } from '../api.module';
import { ApiUserHelperPipe, ApiUserHelperUnpurePipe } from './user-helper.pipe';

@NgModule({
  declarations: [ApiUserHelperPipe, ApiUserHelperUnpurePipe],
  imports: [CommonModule, ApiModule],
  exports: [ApiUserHelperPipe, ApiUserHelperUnpurePipe],
  providers: [ApiUserHelperPipe],
})
export class ApiUserModule {}
